import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: () => {
            return '/login'
        }
    },
    {
        path: '/mobile',
        component: () =>
            import ('../views/mobile/page/mobile'),
        meta: {
            title: '北京首华双暖民生科技发展联盟',
        }
    },
    {
        path: '/login',
        component: () =>
            import ('../views/login'),
        meta: {
            title: '三间有暖-登录',
        }
    },
    {
        path: '/forget',
        component: () =>
            import ('../views/forget'),
        meta: {
            title: '三间有暖-忘记密码',
        }
    },
    {
        path: '/staff',
        component: () =>
            import ('../views/pages/screen/staff'),
        meta: {
            title: '数据统计',
        }
    },

    {
        path: '/community',
        component: () =>
            import ('../views/pages/screen/community'),
        meta: {
            title: '数据统计',
        }
    },
    {
        path: '/manager',
        component: () =>
            import ('../views/pages/screen/manager'),
        meta: {
            title: '数据统计',
        }
    },
    {
        path: '/digitize/all',
        component: () =>
            import ('../views/digitize/page/all'),
        meta: {
            title: '数据统计',
        }
    },
    {
        path: '/digitize/building',
        component: () =>
            import ('../views/digitize/page/building'),
        meta: {
            title: '数据统计',
        }
    },
    {
        path: '/digitize/team_development',
        component: () =>
            import ('../views/digitize/page/team_development'),
        meta: {
            title: '数据统计',
        }
    },
    {
        path: '/digitize/service_rank',
        component: () =>
            import ('../views/digitize/page/service_rank'),
        meta: {
            title: '数据统计',
        }
    },
    {
        path: '/digitize/real_time',
        component: () =>
            import ('../views/digitize/page/real_time'),
        meta: {
            title: '数据统计',
        }
    },
    //双暖孝亲信息服务平台 大屏
    {
        path: '/digitize/service_info',
        component: () =>
            import ('../views/digitize/page/service_info'),
        meta: {
            title: '双暖孝亲信息服务平台',
        }
    },
    {
        path: '/digitize/health_info',
        component: () =>
            import ('../views/digitize/page/health_info'),
        meta: {
            title: '双暖24小时健康监测',
        }
    },
    {
        path: '/digitize/service_safety',
        component: () =>
            import ('../views/digitize/page/service_safety'),
        meta: {
            title: '安全守护平台',
        }
    },
    {
        path: '/digitize/service_flove',
        component: () =>
            import ('../views/digitize/page/service_flove'),
        meta: {
            title: '亲情守护信息平台',
        }
    },
    //就问陪 大屏
    {
        path: '/digitize/monitoring',
        component: () =>
            import ('../views/digitize/page/monitoring'),
        meta: {
            title: '健康监测',
        }
    },
    {
        path: '/digitize/monitoring_watcher',
        component: () =>
            import ('../views/digitize/page/monitoring_watcher'),
        meta: {
            title: '监控对象',
        }
    },
    {
        path: '/home',
        component: () =>
            import ('../views/home'),
        children: [
            {
                path: '',
                redirect: 'index-statistics'
            },
            {
                path: 'index-statistics',
                meta: {
                    title: '首页统计',
                },
                component: () => import('../views/pages/index-statistics'),
            },
            {
                path: 'party-building',
                meta: {
                    title: '党的建设',
                },
                component: () => import('../views/pages/party-building'),
            },
            {
                path: 'notice',
                meta: {
                    title: '通知公告',
                },
                component: () => import('../views/pages/notice'),
            },
            {
                path: 'notice-edit',
                meta: {
                    title: '通知公告-编辑',
                },
                component: () => import('../views/pages/notice-edit'),
            },
            {
                path: 'notice-detail/:id',
                meta: {
                    title: '通知公告-详情',
                },
                component: () => import('../views/pages/notice-detail'),
            },
            {
                path: 'synthesize-reform',
                meta: {
                    title: '综合改造',
                },
                component: () => import('../views/pages/synthesize-reform'),
            },
            {
                path: 'poll',
                meta: {
                    title: '民意调查',
                },
                component: () => import('../views/pages/poll'),
            },
            {
                path: 'merdeka-center',
                meta: {
                    title: '独立民调',
                },
                component: () => import('../views/pages/merdeka-center'),
            },
            {
                path: 'merdeka-center-range/:id/:cid',
                meta: {
                    title: '独立民调-民调范围',
                },
                component: () => import('../views/pages/merdeka-center-range'),
            },
            {
                path: 'merdeka-center-result/:id',
                meta: {
                    title: '独立民调-民调结果',
                },
                component: () => import('../views/pages/merdeka-center-result'),
            },
            {
                path: 'property-management',
                meta: {
                    title: '物业管理',
                },
                component: () => import('../views/pages/property-management'),
            },
            {
                path: 'property-statistics',
                meta: {
                    title: '物业统计',
                },
                component: () => import('../views/pages/property-statistics'),
            },
            {
                path: 'property-contract',
                meta: {
                    title: '物业合同',
                },
                component: () => import('../views/pages/property-contract'),
            },
            {
                path: 'property-situation',
                meta: {
                    title: '物业情况',
                },
                component: () => import('../views/pages/property-situation'),
            },

            {
                path: 'property-repair',
                meta: {
                    title: '报修情况',
                },
                component: () => import('../views/pages/property-repair'),
            },


            {
                path: 'resident-data',
                meta: {
                    title: '居民数据',
                },
                component: () => import('../views/pages/resident-data'),
            },
            {
                path: 'label-set',
                meta: {
                    title: '居民标签管理',
                },
                component: () => import('../views/pages/label-set'),
            },
            {
                path: 'housing-data',
                meta: {
                    title: '房屋数据',
                },
                component: () => import('../views/pages/housing-data'),
            },
            {
                path: 'housing-dev/:id',
                meta: {
                    title: '设备管理',
                },
                component: () => import('../views/serve/service-safety-detail'),
            },
            {
                path: 'share-files',
                meta: {
                    title: '共享文件',
                },
                component: () => import('../views/pages/share-files'),
            },
            {
                path: 'commend-complaint',
                meta: {
                    title: '表彰投诉',
                },
                component: () => import('../views/pages/commend-complaint'),
            },


            {
                path: 'account',
                meta: {
                    title: '账号管理',
                },
                component: () => import('../views/pages/account'),
            },
            {
                path: 'project',
                meta: {
                    title: '社区管理',
                },
                component: () => import('../views/pages/project'),
            },
            {
                path: 'community',
                meta: {
                    title: '小区管理',
                },
                component: () => import('../views/pages/community'),
            },
            {
                path: 'floor-management/:cid/:pid',
                meta: {
                    title: '楼宇管理',
                },
                component: () => import('../views/pages/floor-management'),
            },
            {
                path: 'floor-management2/:cid/:pid',
                meta: {
                    title: '楼宇管理',
                },
                component: () => import('../views/pages/floor-management2'),
            },
            {
                path: 'unit-management/:fid/:cid/:pid',
                meta: {
                    title: '楼宇设置',
                },
                component: () => import('../views/pages/unit-management'),
            },


            {
                path: 'info',
                meta: {
                    title: '个人中心',
                },
                component: () => import('../views/pages/info'),
            },
            {
                path: 'server-tj',
                meta: {
                    title: '双暖为老',
                },
                component: () => import('../views/pages/server-tj'),
            },
            {
                path: 'server-category',
                meta: {
                    title: '服务类目管理',
                },
                component: () => import('../views/pages/server-category'),
            },
            {
                path: 'server-shen',
                meta: {
                    title: '申请审核',
                },
                component: () => import('../views/pages/server-shen'),
            },
            {
                path: 'server-list',
                meta: {
                    title: '服务记录',
                },
                component: () => import('../views/pages/server-list'),
            },
            {
                path: 'calculation',
                meta: {
                    title: '积分分配设置',
                },
                component: () => import('../views/pages/calculation'),
            },
            {
                path: 'server-type',
                meta: {
                    title: '服务类目设置',
                },
                component: () => import('../views/pages/server-type'),
            },

            {
                path: 'server-pople',
                meta: {
                    title: '服务对象',
                },
                component: () => import('../views/pages/server-pople'),
            },
            {
                path: 'server-pople-detail/:id',
                meta: {
                    title: '服务对象',
                },
                component: () => import('../views/pages/server-pople-detail'),
            },
            {
                path: 'team-admin',
                meta: {
                    title: '志愿者队长',
                },
                component: () => import('../views/pages/team-admin'),
            },
            {
                path: 'team-admin-detail/:id',
                meta: {
                    title: '志愿者队长详情',
                },
                component: () => import('../views/pages/team-admin-detail'),
            },
            {
                path: 'team-list',
                meta: {
                    title: '双暖服务队',
                },
                component: () => import('../views/pages/team-list'),
            },
            {
                path: 'team-list-edit/:id',
                meta: {
                    title: '双暖服务队-编辑',
                },
                component: () => import('../views/pages/team-list-edit'),
            },
            {
                path: 'team-member',
                meta: {
                    title: '志愿者',
                },
                component: () => import('../views/pages/team-member'),
            },
            {
                path: 'team-member-detail/:id',
                meta: {
                    title: '志愿者详情',
                },
                component: () => import('../views/pages/team-member-detail'),
            },
            {
                path: 'team-member-home/:id',
                meta: {
                    title: '志愿者-家庭成员',
                },
                component: () => import('../views/pages/team-member-home'),
            },
            {
                path: 'shopping',
                meta: {
                    title: '商品管理',
                },
                component: () => import('../views/pages/shopping'),
            },
            {
                path: 'shopping-duihuan',
                meta: {
                    title: '兑换记录',
                },
                component: () => import('../views/pages/shopping-duihuan'),
            },
            {
                path: 'shopping-setting',
                meta: {
                    title: '分配库存',
                },
                component: () => import('../views/pages/shopping-setting'),
            },
            {
                path: 'shopping-caozuo',
                meta: {
                    title: '操作记录',
                },
                component: () => import('../views/pages/shopping-caozuo'),
            },
            {
                path: 'shopping-add/:id',
                meta: {
                    title: '商品编辑',
                },
                component: () => import('../views/pages/shopping-add'),
            },
            {
                path: 'order',
                meta: {
                    title: '订单管理',
                },
                component: () => import('../views/pages/order'),
            },
            {
                path: 'questions-type',
                meta: {
                    title: '试题类型',
                },
                component: () => import('../views/pages/questions-type'),
            },
            {
                path: 'questions-list',
                meta: {
                    title: '试题管理',
                },
                component: () => import('../views/pages/questions-list'),
            },
            {
                path: 'questions-edit/:id',
                meta: {
                    title: '试题编辑',
                },
                component: () => import('../views/pages/questions-edit'),
            },

            {
                path: 'article-list',
                meta: {
                    title: '文章管理',
                },
                component: () => import('../views/pages/article-list'),
            },
            {
                path: 'article-edit/:id',
                meta: {
                    title: '文章编辑',
                },
                component: () => import('../views/pages/article-edit'),
            },
            {
                path: 'video-list',
                meta: {
                    title: '视频管理',
                },
                component: () => import('../views/pages/video-list'),
            },
            {
                path: 'video-edit/:id',
                meta: {
                    title: '视频编辑',
                },
                component: () => import('../views/pages/video-edit'),
            },


            {
                path: 'competition-list',
                meta: {
                    title: '竞赛管理',
                },
                component: () => import('../views/pages/competition-list'),
            },
            {
                path: 'competition-edit/:id',
                meta: {
                    title: '竞赛编辑',
                },
                component: () => import('../views/pages/competition-edit'),
            }, {
                path: 'competition-ranking/:id',
                meta: {
                    title: '竞赛排名',
                },
                component: () => import('../views/pages/competition-ranking'),
            },
            {
                path: 'ranking-list',
                meta: {
                    title: '系统排名',
                },
                component: () => import('../views/pages/ranking-list'),
            },
            {
                path: 'month-finance',
                meta: {
                    title: '财务管理',
                },
                component: () => import('../views/pages/month-finance'),
            },

            {
                path: 'year-finance',
                meta: {
                    title: '财务管理',
                },
                component: () => import('../views/pages/year-finance'),
            },
            {
                path: 'service-object',
                meta: {
                    title: '服务对象',
                },
                component: () => import('../views/serve/service-object'),
            },
            {
                path: 'service-object-detail/:id',
                meta: {
                    title: '服务对象',
                },
                component: () => import('../views/serve/service-object-detail'),
            },
            {
                path: 'safety-dev',
                meta: {
                    title: '安全守护',
                },
                component: () => import('../views/serve/service-safety'),
            },
            {
                path: 'safety-dev-detail/:id',
                meta: {
                    title: '安全守护',
                },
                component: () => import('../views/serve/service-safety-detail'),
            },
            {
                path: 'alert-settings',
                meta: {
                    title: '预警设置',
                },
                component: () => import('../views/serve/alert-settings'),
            },
            {
                path: 'professional',
                meta: {
                    title: '专业人员',
                },
                component: () => import('../views/serve/professional'),
            },
            {
                path: 'disease',
                meta: {
                    title: '病种管理',
                },
                component: () => import('../views/serve/disease'),
            },
            {
                path: 'flove_image',
                meta: {
                    title: '图片管理',
                },
                component: () => import('../views/pages/flove_image'),
            },
            {
                path: 'flove_image/:id',
                meta: {
                    title: '图片管理',
                },
                component: () => import('../views/pages/flove_image-edit'),
            },
            {
                path: 'gzh/active',
                meta: {
                    title: '活动管理',
                },
                component: () => import('../views/gzh/active/list'),
            },
            {
                path: 'gzh/active/add/:id',
                meta: {
                    title: '活动管理',
                },
                component: () => import('../views/gzh/active/add'),
            },
            {
                path: 'gzh/active/record/:id',
                meta: {
                    title: '报名列表',
                },
                component: () => import('../views/gzh/active/record'),
            },
            {
                path: 'gzh/goods',
                meta: {
                    title: '商品管理',
                },
                component: () => import('../views/gzh/goods/list'),
            },
            {
                path: 'gzh/goods/add/:id',
                meta: {
                    title: '商品管理',
                },
                component: () => import('../views/gzh/goods/add'),
            },
            {
                path: 'gzh/goods/record',
                meta: {
                    title: '兑换列表',
                },
                component: () => import('../views/gzh/goods/record'),
            },
            {
                path: 'gzh/member',
                meta: {
                    title: '人员管理',
                },
                component: () => import('../views/gzh/member/list'),
            },
            {
                path: 'gzh/member/points/:id',
                meta: {
                    title: '积分详情',
                },
                component: () => import('../views/gzh/member/points'),
            },
        ],
    }
]

const router = new VueRouter({
    routes,
    base: process.env.BASE_URL,
    mode: 'history',
    scrollBehavior() {
        return {x: 0, y: 0}
    }
})
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err)
}

export default router

